import { PhoneAppCardState, PhoneAppCardErrorState } from './schema/PhoneAppCardState';
import { UserOutlookClientsState } from './schema/UserOutlookClientsState';
import { createStore } from 'satcheljs';

let initialPhoneAppCardState: PhoneAppCardState = {
    errorState: PhoneAppCardErrorState.Init,
};

let initialUserOutlookClientsState: UserOutlookClientsState = { clients: [] };

export let phoneAppCardStore = createStore<PhoneAppCardState>(
    'PhoneAppCardStore',
    initialPhoneAppCardState
);

export let userOutlookClientsStore = createStore<UserOutlookClientsState>(
    'OutlookClientsStore',
    initialUserOutlookClientsState
);
